import React from 'react';

const ReportsContainer = React.lazy(() => import('../../Containers/ReportsContainer'));

// import ReportsContainer from '../../Containers/ReportsContainer';

const Reports = () => {
	return (
		<ReportsContainer />
	);
}

export default Reports;

